import React from 'react';

const AnnouncementBar = ({ message }) => {
  if (!message) return null;
  return (
    <div className="w-full bg-gradient-to-r from-brand-blue/20 via-brand-purple/20 to-brand-blue/20 border-b border-brand-border text-brand-text text-sm py-2 px-4 text-center">
      <span className="inline-flex items-center gap-2">
        <span className="inline-block w-2 h-2 rounded-full bg-brand-green animate-pulse" />
        <span className="font-medium">{message}</span>
      </span>
    </div>
  );
};

export default AnnouncementBar;
